export const classesConstants = {
  GET_CLASSES: "GET_CLASSES",
  GET_MY_CLASSES: "GET_MY_CLASSES",
  GET_MY_NOW_CLASSES: "GET_MY_NOW_CLASSES",
  GET_MY_ALL_CLASSES: "GET_MY_ALL_CLASSES",
  GET_CLASSE: "GET_CLASSE",
  CREATE: "CREATE",

  GET_ETUDIANTS: "GET_ETUDIANTS",
  GET_INSCRIPTIONS: "GET_INSCRIPTIONS",
  GET_ABANDONS: "GET_ABANDONS",

  GET_PROGRAMME: "GET_PROGRAMME",
  GET_COMMUN: "GET_COMMUN",
  GET_UES: "GET_UES",
  GET_UE: "GET_UE",
  GET_ECS: "GET_ECS",
  GET_EC: "GET_EC",
  GET_ECUES: "GET_ECUES",
  GET_ECUE: "GET_ECUE",
  GET_SEMESTRES: "GET_SEMESTRES",
  GET_ALL_SEMESTRES: "GET_ALL_SEMESTRES",
};
